import GameDetails from 'components/Content/GameDetails/GameDetails';
import { withGameDetailsProps } from 'viewModel/content/gameDetails/withGameDetailsProps';

export default withGameDetailsProps(GameDetails);
